/**
 * @license
 * Copyright Akveo. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */
import { Component, OnInit } from '@angular/core';
import { AnalyticsService } from './@core/utils/analytics.service';
import { TranslateService } from '@ngx-translate/core';
import { AuthService } from './auth/auth.service';
// import { MessagingService } from '../app/services/push.service';

@Component({
  selector: 'ngx-app',
  template: '<router-outlet></router-outlet>',
})
export class AppComponent implements OnInit {

  message;

  constructor(private analytics: AnalyticsService, public translate: TranslateService, private authService: AuthService) {
    let languages = ['pt-br', 'es-es', 'en-us'];
    let userLanguage = JSON.parse(sessionStorage.getItem('credentials'))
    this.translate.addLangs(languages)
    this.translate.setDefaultLang(languages[0]);
    if (localStorage.getItem('language')) {
      this.translate.use(localStorage.getItem('language'));
      this.translate.setDefaultLang(localStorage.getItem('language'));
    }
    if (authService.isAuthenticated() && userLanguage) {
      this.translate.use(userLanguage.user.usuarioIdioma);
      this.translate.setDefaultLang(userLanguage.user.usuarioIdioma);
    }
  }

  switchLang(lang: string){
    this.translate.setDefaultLang(lang);
    this.translate.use(lang);
    localStorage.setItem('language', lang);
  }

  ngOnInit(): void {
    if (localStorage.getItem('language') && !this.authService.isAuthenticated()) {
      this.translate.use(localStorage.getItem('language'));
      this.translate.setDefaultLang(localStorage.getItem('language'));
    }
    if (this.authService.isAuthenticated()) {
      let userLanguage = JSON.parse(sessionStorage.getItem('credentials')).user.usuarioIdioma
      this.translate.use(userLanguage);
      this.translate.setDefaultLang(userLanguage);
    }
  }
}
